import { Button, Col, Form, Input, Modal, Row, Typography } from "antd";

const { Title } = Typography;

interface ItemOptionsModalProps {
  open: boolean;
  title: string;
  value: string;
  onChange: (value: string) => void;
  onCancel: () => void;
  onSave: (value: string) => void;
  isLoading?: boolean;
  placeholder?: string;
  saveButtonText?: string;
  cancelButtonText?: string;
}

const ItemOptionsModal = ({
  open,
  title,
  value,
  onChange,
  onCancel,
  onSave,
  isLoading = false,
  placeholder = "",
  saveButtonText = "Save",
  cancelButtonText = "Cancel",
}: ItemOptionsModalProps) => {
  return (
    <Modal
      className="delete-confirm-modal"
      open={open}
      centered
      width={700}
      onCancel={onCancel}
      closable={false}
      footer={null}
    >
      <Row>
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Title level={5}>{title}</Title>
              <Form.Item>
                <Input
                  value={value}
                  onChange={(e) => onChange(e?.target?.value || "")}
                  className="fp_input"
                  placeholder={placeholder}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="btn-main" justify="center">
            <Col>
              <Button
                className="fp_btn fp_btn-outline"
                shape="round"
                onClick={onCancel}
              >
                {cancelButtonText}
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                shape="round"
                className="fp_btn fp_btn-primary"
                onClick={() => onSave(value)}
              >
                {saveButtonText}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
};

export default ItemOptionsModal;